import DrawerSectionHeading from '../DrawerSectionHeading';
import SortableTopPosts from './SortableTopPosts';
import Stack from '../Stack';
import TopPostsDownloadButton from './TopPostsDownloadButton';
import { useCurrentCountry } from 'utils/hooks';
import { useTopPosts } from 'utils/hooks/api';
import { useTopPostsControls } from './useTopPostsControls.hook';

function TopPostsDrawer({
    year,
    week,
    categories,
    brands,
    countries,
    displayQty = 5,
    name,
}) {
    const country = useCurrentCountry();
    const {
        sortSelect,
        value,
        defaultSortOption,
        visibleOrderedMetrics,
        columnsMenu,
    } = useTopPostsControls({
        week,
        year,
        mixpanelContext: 'TopPostsSortSelect',
        tableName: 'top-posts-section-card-tiktok',
    });
    const topPostsQuery = useTopPosts({
        year: value.year,
        week: value.week,
        countries,
        categories,
        brands,
        rank_type: value.apiRankType,
    });
    return (
        <Stack $space="1rem">
            <DrawerSectionHeading>
                <span css="display: flex; align-items: center;">Top Posts</span>
                <span css="margin-left: auto;">
                    <TopPostsDownloadButton
                        year={value.year}
                        week={value.week}
                        name={name}
                        country={country}
                        source="tiktok"
                        topPostsQuery={topPostsQuery}
                        visibleOrderedMetrics={visibleOrderedMetrics}
                    />
                </span>
            </DrawerSectionHeading>
            <Stack
                css="display: flex; justify-content: space-between;"
                $space=".25rem"
                $direction="row"
            >
                {sortSelect}
                {columnsMenu}
            </Stack>
            <SortableTopPosts
                topPostsQuery={topPostsQuery}
                displayQty={displayQty}
                sortOption={defaultSortOption}
                visibleOrderedMetrics={visibleOrderedMetrics}
            />
        </Stack>
    );
}

export default TopPostsDrawer;
